import { NgModule } from '@angular/core';
import { DomsanitizerPipe } from 'src/app/_utils/_pipes/domsanitizer.pipe';
import { EuroCurrencyPipe } from 'src/app/_utils/_pipes/euro-currency.pipe';
import { MaxCharactersPipe } from 'src/app/_utils/_pipes/maxCharacters.pipe';
import { NumeroTelefonoSeparadoPipe } from './numero-telefono-separado.pipe';
import { CapitalizeFirstLetterPipe } from 'src/app/_utils/_pipes/capitalize-first-letter.pipe';
import { DecimalFormatPipe } from 'src/app/_utils/_pipes/decimal-format.pipe';
import { ThousandSeparatorPipe } from './thousand-separator.pipe';


@NgModule({
  declarations: [
    DomsanitizerPipe,
    EuroCurrencyPipe,
    MaxCharactersPipe,
    CapitalizeFirstLetterPipe,
    NumeroTelefonoSeparadoPipe,
    DecimalFormatPipe,
    ThousandSeparatorPipe
  ],
  exports: [
    DomsanitizerPipe,
    EuroCurrencyPipe,
    MaxCharactersPipe,
    CapitalizeFirstLetterPipe,
    NumeroTelefonoSeparadoPipe,
    DecimalFormatPipe,
    ThousandSeparatorPipe
  ]
})
export class PipesModule { }
